import { createTheme, Theme } from '@mui/material/styles';

export const getTheme = (mode: 'light' | 'dark'): Theme =>
  createTheme({
    palette: {
      mode,
      primary: { main: '#ffa100' },
      secondary: { main: '#ed2020' },
      ...(mode === 'dark'
        ? {
            background: { default: '#121212', paper: '#1e1e1e' },
            text: { primary: '#ffffff', secondary: '#bbbbbb' },
          }
        : {
            background: { default: '#ffffff', paper: '#f8f8f8' },
            text: { primary: '#212529', secondary: '#4b5563' },
          }),
    },
    typography: {
      // 1. Sets the font for the entire app (Body, Headers, Buttons)
      fontFamily: "'Inter', sans-serif", 
      
      // 2. Button specific overrides
      button: {
        fontFamily: "'Inter', sans-serif", // Ensure it applies specifically to buttons
        textTransform: 'none', // Prevents MUI's default UPPERCASE button text  
      },
    },
    // 3. (Optional) Force CSS overrides via the Component layer
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            fontFamily: "'Inter', sans-serif",
          },
        },
      },
    },
  });